module.exports = __webpack_public_path__ + "img/image-not-found.95879f04.png";